module.exports = __webpack_public_path__ + "8b53532f67ec1b8c35d855c5c724766a.svg";